<template>
  <b-container>
    <div class="container-center-horizontal">
      <header class="header">
          <b-row>
            <b-col cols="8"><img src="../img/nav_bar_logo.png" height="30"/></b-col>
          </b-row>
      </header>
      <div class="x3-varijanta animate-enter1 screen">
        <b-row>
          <b-col cols="12">
            <div class="overlap-group6">
              <div class="credo-container">
                <div class="hero-credo">
                  <div class="frame-4">
                    <img class="solo-logo-protokol-beli-8" :src="soloLogoProtokolBeli8" alt="solo logo protokol beli 8" />
                    <div class="frame-5">
                      <div class="group-33">
                        <div class="overlap-group inter-medium-white-36px">
                          <div class="upravljaj valign-text-bottom">{{ upravljaj }}</div>
                          <div class="integrii valign-text-bottom">
                            <span
                              ><span class="inter-medium-white-36px">{{ spanText1 }}</span
                              ><span class="inter-semi-bold-white-36px">{{ spanText2 }}</span>
                            </span>
                          </div>
                          <div class="automatizuj valign-text-bottom">
                            <span
                              ><span class="inter-medium-white-36px">{{ spanText3 }}</span
                              ><span class="inter-semi-bold-white-36px">{{ spanText4 }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <img class="credo-sentence" :src="credoSentence" alt="credo sentence" />
              </div>
              <div class="premium">
                <b-row>
                  <b-col cols="12" md="6" class="mb-3">
                    <starter :analitikaPotrazivanjaIDugovanjaProps="starterProps.analitikaPotrazivanjaIDugovanjaProps" @start="registrationModal"/></b-col>
                  <b-col cols="12" md="6"><premium
                    :analitikaPotrazivanjaIDugovanja1Props="premiumProps.analitikaPotrazivanjaIDugovanja1Props"
                    :analitikaPotrazivanjaIDugovanja2Props="premiumProps.analitikaPotrazivanjaIDugovanja2Props"
                    @start="registrationModal"
                  /></b-col>
                  
                </b-row>

                <b-modal v-model="showRegistrationModal" ok-title="Registruj se" @ok="triggerRegister" ok-only>
                  <b-form-group label="PIB">
                    <b-form-input v-model="pib" />
                  </b-form-group>

                  <b-form-group label="Bankovni račun">
                    <b-form-input v-model="bankAccount" />
                  </b-form-group>
                </b-modal>
                
                
              </div>

              <b-row>
                  <b-col cols="12">Registracijom prihvatate <a href="https://envoy.fra1.cdn.digitaloceanspaces.com/tos/protokol_poslovodja_uslovi_koriscenja_01062023.pdf" target="_blank">uslove korišćenja</a>.</b-col>
                </b-row>

              <support-info :excepteurSintOccae="supportInfoProps.excepteurSintOccae" />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="overlap-group5 mt-5">
            <b-row class="mt-5">
              <b-col cols="12"> <protokol-ekosistem :className="protokolEkosistemProps.className" /></b-col>
              <b-col cols="12"> <sva-poslovna-resenja-na-jednom-mestu /></b-col>
            </b-row>
          </div>
        </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="frame-9">
              <b-row>
                <b-col cols="12" md="4" class="mb-3"><x1 :bgProps="x1Props.bgProps" /></b-col>
                <b-col cols="12" md="4" class="mb-3"><x2 :iconProps="x2Props.iconProps" /></b-col>
                <b-col cols="12" md="4" class="mb-3"><x3 :iconProps="x3Props.iconProps" /></b-col>
                <b-col cols="12" md="4" class="mb-3"><x4 :bgProps="x4Props.bgProps" /></b-col>
                <b-col cols="12" md="4" class="mb-3"><x5 /></b-col>
                <b-col cols="12" md="4" class="mb-3"> <x6 :bgProps="x6Props.bgProps" /></b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-5" align-h="center">
            <b-col cols="12" style="padding-top:50px;border-top: 1px solid #fff">
              <b-row>
                <b-col cols="12" md="6">
                  <b-col cols="12"><div class="more-speed-less-spe architectsdaughter-normal-blueberry-20px">{{ moreSpeedLessSpe1 }}</div></b-col>
                    <b-col cols="12">
                        <div class="d-md-down-block d-md-none">
                          <span class="inter-bold-link-water-32px">{{ spanText5 }}</span
                          >
                            <br />
                          <span class="inter-normal-link-water-32px">{{ spanText6 }}</span>
                        </div>

                        <div class="d-md-down-none">
                          <span class="inter-bold-link-water-32px">{{ spanText5 }}</span
                          ><span class="inter-normal-link-water-32px">{{ spanText6 }}</span>
                        </div>
                    </b-col>
                    <b-col cols="12">
                      <p class="lorem-ipsum-dolor-si inter-normal-gull-gray-20px">
                        jednostavan način za rukovođenjem vašeg poslovanja, upravljajte finansijama, stanjem robe, uslugama, potraživanjima i dugovanjima.
                      </p>
                    </b-col>

                    <b-col cols="12" class="mt-4 inter-normal-gull-gray-20px">
                      <ul> 
                        <li> <i class="fa fa-check" style="color:green"></i> Kreiraj fakture u par klikova </li>  
                        <li> <i class="fa fa-check" style="color:green"></i> Pregled statusa svih transakcija u svakom trenutku </li>
                        <li> <i class="fa fa-check" style="color:green"></i> Analitika kupaca, dobavljača, prometa, zaliha robe... </li>
                      </ul>
                    </b-col>
                  </b-col>
                  <b-col cols="12" md="6"></b-col>
              </b-row>
            </b-col>

            <b-col cols="12" class="m-4">
              <b-row>
                <b-col cols="12" md="6"></b-col>
                <b-col cols="12" md="6">
                  <b-col cols="6"><div class="more-speed-less-spe architectsdaughter-normal-blueberry-20px">{{ moreSpeedLessSpe1 }}</div></b-col>
                    <b-col cols="12">
                        <div class="d-md-down-block d-md-none">
                          <span class="inter-bold-link-water-32px"> Arhivator </span
                          >
                            <br />
                          <span class="inter-normal-link-water-32px"> sva dokumenta na klik </span>
                        </div>

                        <div class="d-md-down-none">
                          <span class="inter-bold-link-water-32px"> Arhivator </span
                          ><span class="inter-normal-link-water-32px">sva dokumenta na klik</span>
                        </div>
                    </b-col>
                    <b-col cols="12">
                      <p class="lorem-ipsum-dolor-si inter-normal-gull-gray-20px">
                        Jedno mesto za svu poslovnu dokumentaciju, dostupno, 365 dana u godini, sa obaveštenjima o svim rokovima, i obavezama uz automatizaciju procesa
                      </p>
                    </b-col>

                    <b-col cols="12" class="mt-4 inter-normal-gull-gray-20px">
                      <ul> 
                        <li> <i class="fa fa-check" style="color:green"></i> Sva dokumenta potpuno sigurna u klaudu </li>  
                        <li> <i class="fa fa-check" style="color:green"></i> Dostupnost 24/7 svim saradnicima i partnerima </li>
                        <li> <i class="fa fa-check" style="color:green"></i> Povezivanje dokumentara i automatizacija procesa </li>
                      </ul>
                    </b-col>
                  </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" class="m-4">
              <b-row>
                <b-col cols="12" md="6">
                  <b-col cols="12"><div class="more-speed-less-spe architectsdaughter-normal-blueberry-20px">{{ moreSpeedLessSpe1 }}</div></b-col>
                    <b-col cols="12">
                        <div class="d-md-down-block d-md-none">
                          <span class="inter-bold-link-water-32px">eCommerce </span
                          >
                            <br />
                          <span class="inter-normal-link-water-32px"> po vašoj meri </span>
                        </div>

                        <div class="d-md-down-none">
                          <span class="inter-bold-link-water-32px">eCommerce </span
                          ><span class="inter-normal-link-water-32px"> po vašoj meri</span>
                        </div>
                    </b-col>
                    <b-col cols="12">
                      <p class="lorem-ipsum-dolor-si inter-normal-gull-gray-20px">
                        Počnite da zaradjujete jednim klikom putem ecommerce resenja ili B2B portala uz automatska ažuriranja stanja i prometa
                      </p>
                    </b-col>

                    <b-col cols="12" class="mt-4 inter-normal-gull-gray-20px">
                      <ul> 
                        <li> <i class="fa fa-check" style="color:green"></i> Brzo i jednostavno do web prodavnice </li>  
                        <li> <i class="fa fa-check" style="color:green"></i> Sinhronizacija podataka u okviru platforme </li>
                        <li> <i class="fa fa-check" style="color:green"></i> Automatizacija poručivanja i dostave </li>
                      </ul>
                    </b-col>
                  </b-col>
                  <b-col cols="12" md="6"></b-col>
              </b-row>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <moto2 />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <div class="partneri-lista">
              <div class="text">
                <div class="strateski-partneri">{{ strateskiPartneri }}</div>
              </div>
              <otp-transprarent2 />
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
             <frame52 />
          </b-col>
        </b-row>

      </div>
    </div>
  </b-container>
</template>

<script>
import OtpTransprarent2 from "./OtpTransprarent2";
import Moto2 from "./Moto2";
import X4 from "./X4";
import X5 from "./X5";
import X6 from "./X6";
import X1 from "./X1";
import X2 from "./X2";
import X3 from "./X3";
import ProtokolEkosistem from "./ProtokolEkosistem";
import SvaPoslovnaResenjaNaJednomMestu from "./SvaPoslovnaResenjaNaJednomMestu";
import Starter from "./Starter";
import Premium from "./Premium";
import SupportInfo from "./SupportInfo";
import Frame52 from "./Frame52";
import X12 from "./X12";

import "../styleguide.css"
import "../globals.css"

export default {
  name: "X3Varijanta",
  components: {
    OtpTransprarent2,
    Moto2,
    X4,
    X5,
    X6,
    X1,
    X2,
    X3,
    ProtokolEkosistem,
    SvaPoslovnaResenjaNaJednomMestu,
    Starter,
    Premium,
    SupportInfo,
    Frame52,
    X12,
  },
  props: [
    "footerINewsletter",
    "resources",
    "nostrudExercitation1",
    "visualMockups",
    "nostrudExercitation2",
    "company",
    "consecteturAdipisci1",
    "laboreEtDolore",
    "consecteturAdipisci2",
    "strateskiPartneri",
    "activateLogo_Mono_Darkbg1",
    "vector2",
    "x13",
    "headerNavBar",
    "soloLogoProtokolBeli8",
    "upravljaj",
    "spanText1",
    "spanText2",
    "spanText3",
    "spanText4",
    "credoSentence",
    "x12",
    "x15",
    "x14",
    "moreSpeedLessSpe1",
    "spanText5",
    "spanText6",
    "loremIpsumDolorSi1",
    "ametConsecteturAdi",
    "path2",
    "excepteurSintOccae1",
    "path3",
    "duisAuteIrureDolo",
    "arhivator",
    "moreSpeedLessSpe2",
    "spanText7",
    "spanText8",
    "loremIpsumDolorSi2",
    "excepteurSintOccae2",
    "path4",
    "x4Props",
    "x6Props",
    "x1Props",
    "x2Props",
    "x3Props",
    "protokolEkosistemProps",
    "starterProps",
    "premiumProps",
    "supportInfoProps",
    "x121Props",
    "x122Props",
  ],

  data: function() {
    return {
      showRegistrationModal: false,
      pib: null,
      bankAccount: null,
      package: null
    }
  },

  methods: {
    triggerRegister() {
      let popup = this.$loadingPopup()
      this.$integrationApi.post("/otp/register", {vat_number: this.pib, bank_number: this.bankAccount, package: this.package}).then((link) => {
        window.open(link.data.link, "_self")
      }).catch(err => {
        if (err.response) {
          if (err.response.status == 409) {
            this.$bvModal.msgBoxOk("Nalog je već registrovan u našem sistemu. Ako mislite da je ovo greška molim vas kontaktirajte korisničku podršku.")
            return
          }

          if (err.response.status == 400) {
            this.$bvModal.msgBoxOk(err.response.data.message)
            return
          }
        }

        this.$bvModal.msgBoxOk("Došlo je do greške pri registraciji. Ukolite se greška nastavi molimo vas kontaktirajte korisničku podršku.")
      }).finally(() => {
         popup.hide()
      })
    },

    registrationModal(d) {
      this.showRegistrationModal = true
      this.package = d
    }
  }
};
</script>

<style>
.header {
  background-color: #25282C;
  width: 100%;
  position: absolute;
  top: 0;
  padding: 20px;
  font-family: var(--font-family-inter)
}

.form-group {
  font-family: var(--font-family-inter)
}

.btn {
  font-family: var(--font-family-inter)
}

.x3-varijanta {
  /* background-color: var(--eerie-black); */
  border: 0px none;
  opacity: 0;
  position: relative;
  width: 100%;
  margin-top: 120px;
  font-family: var(--font-family-inter)
}

.x3-varijanta.animate-enter1 {
  animation: animate-enter1-frames 0.2s ease-in-out 0s 1 normal forwards;
  opacity: 0;
}

.footer-container {
  height: 526px;
  left: 163px;
  position: absolute;
  top: 4674px;
  width: 754px;
}

.footer-i-newsletter {
  display: block;
  height: 205px;
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 754px;
}

.footer-i-newsletter.animate-enter {
  animation: animate-enter-frames 0.5s ease-in-out 0s 1 normal forwards;
  display: block;
  opacity: 0;
}

.footer {
  align-items: flex-start;
  background-color: transparent;
  display: flex;
  gap: 16px;
  height: auto;
  justify-content: center;
  left: 277px;
  mix-blend-mode: normal;
  padding: 16px 0px;
  position: absolute;
  top: 204px;
  width: fit-content;
}

.bottom {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 29px;
  height: 290px;
  position: relative;
  width: 200px;
}

.resursi {
  align-self: stretch;
  height: 152px;
  min-width: 200px;
  position: relative;
}

.resources {
  left: 0;
  letter-spacing: 0;
  line-height: 22px;
  position: absolute;
  top: 0;
  white-space: nowrap;
  width: 68px;
}

.frame-1 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
  left: 0;
  position: absolute;
  top: 26px;
  width: fit-content;
}

.nostrud-exercitation {
  cursor: pointer;
  letter-spacing: 0;
  line-height: 22px;
  margin-top: -1px;
  position: relative;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}

.link {
  cursor: pointer;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  text-decoration: underline;
  white-space: nowrap;
  width: fit-content;
}

.informacije {
  align-self: stretch;
  height: 152px;
  margin-bottom: -43px;
  min-width: 200px;
  position: relative;
}

.company {
  left: 0;
  letter-spacing: 0;
  line-height: 22px;
  position: absolute;
  top: 0;
  white-space: nowrap;
  width: 98px;
}

.consectetur-adipisci {
  cursor: pointer;
  letter-spacing: 0;
  line-height: 22px;
  margin-top: -1px;
  position: relative;
  text-decoration: underline;
  white-space: nowrap;
  width: 148px;
}

.labore-et-dolore {
  cursor: pointer;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  text-decoration: underline;
  white-space: nowrap;
  width: 134px;
}

.consectetur-adipisci-1 {
  cursor: pointer;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
  text-decoration: underline;
  white-space: nowrap;
  width: 133px;
}

.partneri-lista {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 50px 7px;
  margin: 0 auto;
  border-top: 1px solid #fff;
}

.text {
  align-items: center;
  align-self: stretch;
  display: flex;
  height: 86px;
  min-width: 300px;
  position: relative;
}

.strateski-partneri {
  color: var(--link-water);
  flex: 1;
  font-family: var(--font-family-inter);
  font-size: 32px;
  font-weight: 500;
  height: 50px;
  letter-spacing: -0.5px;
  line-height: 50px;
  margin-top: -36px;
  text-align: center;
  white-space: nowrap;
}

.activate-logo_mono_dark-bg-1 {
  height: 50.82px;
  min-width: 300px;
  object-fit: cover;
  position: relative;
}

.vector {
  height: 75.27px;
  min-width: 300px;
  position: relative;
}

.vector-1 {
  height: 50.9px;
  min-width: 300px;
  position: relative;
}

.frame-10 {
  align-items: center;
  display: flex;
  gap: 32px;
  justify-content: center;
  position: relative;
  top: 1550px;
  margin: 0 auto;
}

.frame-9 {
  align-items: center;
  display: flex;
  gap: 32px;
  justify-content: center;
  position: relative;
  margin: 0 auto;
  border-top: 1px solid #fff;
  padding-top: 80px;
}

.overlap-group5 {
  position: relative;
  margin: 0 auto;
  border-top: 1px solid #fff;
}

.x13 {
  height: 431px;
  left: 0;
  position: absolute;
  top: 0;
  width: 600px;
}

.overlap-group6 {
  align-items: center;
  display: flex;
  flex-direction: column;
  left: 0;
  top: 0;
  width: 100%;
}

.header-nav-bar {
  height: 64px;
  width: 100%;
}

.credo-container {
  margin-left: 2px;
  margin-top: 31px;
  position: relative;
  width: 720px;
}

.hero-credo {
  align-items: center;
  display: flex;
  gap: 42px;
  height: 200px;
  justify-content: center;
  left: 0;
  top: 0;
  width: 720px;
}

.frame-4 {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  justify-content: center;
  position: relative;
  width: fit-content;
}

.solo-logo-protokol-beli-8 {
  height: 137px;
  min-width: 86px;
  object-fit: cover;
  position: relative;
}

.frame-5,
.features-bullets {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: fit-content;
}

.group-33 {
  height: 137px;
  margin-right: -6px;
  min-width: 219px;
  position: relative;
}

.overlap-group {
  height: 137px;
  position: relative;
  width: 213px;
}

.upravljaj {
  height: 50px;
  left: 57px;
  letter-spacing: 0;
  line-height: 50.4px;
  position: absolute;
  top: 87px;
  white-space: nowrap;
}

.integrii {
  height: 50px;
  left: 64px;
  letter-spacing: 0;
  line-height: 50.4px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.automatizuj {
  height: 50px;
  left: 0;
  letter-spacing: 0;
  line-height: 50.4px;
  position: absolute;
  top: 44px;
  white-space: nowrap;
}

.credo-sentence {
  height: 73px;
  left: 184px;
  position: absolute;
  top: 181px;
  width: 350px;
}

.premium {
  align-items: center;
  display: flex;
  gap: 48px;
  justify-content: center;
  margin-right: 1px;
  margin-top: 101px;
  position: relative;
  width: fit-content;
}

.x12 {
  height: 1px;
  left: 240px;
  position: absolute;
  top: 2531px;
  width: 600px;
}

.x15 {
  height: 1px;
  left: 240px;
  position: absolute;
  top: 2861px;
  width: 600px;
}

.x14 {
  height: 1px;
  left: 240px;
  position: absolute;
  top: 4151px;
  width: 600px;
}

.description-box {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 36px;
  justify-content: center;
  padding: 40px 20px;
  position: relative;
}

.poslovodja {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 337px;
  justify-content: center;
  position: relative;
  width: 750px;
}

.frame-13 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  margin-bottom: -29px;
  margin-top: -29px;
  padding: 40px 0px;
  position: relative;
}

.poslovodja-1 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 38px;
  position: relative;
  width: fit-content;
}

.zaglavlje {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 9px;
  position: relative;
  width: fit-content;
}

.more-speed-less-spe {
  letter-spacing: 0.25px;
  line-height: 30px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.keep-projects-on-sch {
  letter-spacing: -0.25px;
  line-height: 42px;
  position: relative;
  white-space: nowrap;
  width: 500px;
}

.lorem-ipsum-dolor-si {
  letter-spacing: -0.25px;
  line-height: 30px;
}

.bullet-points {
  height: 97px;
  min-width: 476px;
  position: relative;
}

.overlap-group-1 {
  height: 27px;
  left: 0;
  position: absolute;
  top: 70px;
  width: 476px;
}

.x3 {
  display: flex;
  gap: 8px;
  height: 27px;
  left: 0;
  position: absolute;
  top: 0;
  width: 476px;
}

.path {
  height: 8.99px;
  margin-top: 9px;
  width: 11.98px;
}

.amet-consectetur-adi {
  height: 27px;
  letter-spacing: -0.25px;
  line-height: 27px;
  white-space: nowrap;
  width: 456px;
}

.x2 {
  display: flex;
  gap: 8px;
  height: 27px;
  left: 0;
  position: absolute;
  top: 0;
  width: 438px;
}

.path-1 {
  height: 8.99px;
  margin-top: -26px;
  width: 11.98px;
}

.excepteur-sint-occae {
  height: 27px;
  letter-spacing: -0.25px;
  line-height: 27px;
  margin-top: -37px;
  white-space: nowrap;
  width: 419px;
}

.x1 {
  align-items: flex-start;
  display: flex;
  gap: 8px;
  height: 27px;
  left: 0;
  position: absolute;
  top: 0;
  width: 331px;
}

.path-2 {
  align-self: center;
  height: 9px;
  margin-bottom: 0.01px;
  width: 12px;
}

.duis-aute-irure-dolo {
  letter-spacing: -0.25px;
  line-height: 27px;
  margin-top: -2px;
  white-space: nowrap;
}

.frame-12 {
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 32px 0px 48px;
  position: relative;
  text-align: right;
}

.arhivator {
  height: 313px;
  min-width: 500px;
  position: relative;
}

.ecommerce-po-vasoj-meri {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: 750px;
}

.x3-1 {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  position: relative;
  width: 500px;
}

.text-1 {
  display: flex;
  flex-direction: column;
  gap: 87.1px;
  height: 382.08px;
  margin-right: -91.74px;
  min-width: 591.74px;
  position: relative;
}

.zaglavlje-ecommerce {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  height: 180px;
  justify-content: center;
  padding: 9px 0px;
  position: relative;
  width: 591.74px;
}

.more-speed-less-spe-1 {
  letter-spacing: 0.25px;
  line-height: 30px;
  position: relative;
  white-space: nowrap;
  width: 591.74px;
}

.keep-projects-on-sch-1 {
  align-self: stretch;
  letter-spacing: -0.25px;
  line-height: 42px;
  position: relative;
  white-space: nowrap;
}

.lorem-ipsum-dolor-si-1 {
  align-self: stretch;
  letter-spacing: -0.25px;
  line-height: 30px;
  position: relative;
}

.features-ecommerce {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 2px;
  height: 114.96px;
  justify-content: center;
  position: relative;
  width: 431.6px;
}

.x2-1 {
  align-self: stretch;
  height: 36.99px;
  min-width: 431.6px;
  overflow: hidden;
  position: relative;
}

.excepteur-sint-occae-1 {
  left: 23px;
  letter-spacing: -0.25px;
  line-height: 27px;
  position: absolute;
  top: 4px;
  white-space: nowrap;
  width: 421px;
}

.path-3 {
  height: 12px;
  left: 0;
  position: absolute;
  top: 12px;
  width: 14px;
}

@keyframes animate-enter1-frames {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes animate-enter-frames {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
